import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { GotoHomePageIcon, RechargeIconWhite, RegistrationSuccessIcon } from "../../icon";
import { PhoneNumberData } from "../../models/add-phone-number.model";
import { mapToOrganizationDetails } from "../../models/organization.model";
import { PhoneNumberStatus } from "../../models/phone-number.model";
import { PlanType } from "../../models/plans.model";
import { RechargeStatus } from "../../models/transaction-history.model";
import { OrganizationService } from "../../services/OrganizationService";
import { SettingsService } from "../../services/SettingsService";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels } from "../shared/constants";
import RegistraionLoaderAminationData from "../shared/loaders/add-phone-registration-loader.json";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import { useEffect } from "react";
import { setRefreshHandler } from "../../helpers/header.helper";

interface IProps {
    Status: boolean
    IsMobileDevice?: boolean;
    PhoneNumberData?: PhoneNumberData;
    IsNewPhoneNumberFlow?: boolean;
}

const RegistrationStatus = (props: IProps) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const goToHome = (e: any) => {
        e.preventDefault()
        const redirectURL = UserService.hasSysAdminRole() ? props.IsNewPhoneNumberFlow ? AppRoutes.NEW_PhONE_NUMBER : AppRoutes.PHONE_NUMBERS : AppRoutes.PLANS;
        navigate(redirectURL)
    }

    const goToRecharge = (e: any) => {
        e.preventDefault()
        const id = state?.OrganizationID || props.PhoneNumberData.organizationId
        // SettingsService.getManualsubscription(id, "MS").then(setting =>
        OrganizationService.getOrganizationById(id).then(res => {
            let org = mapToOrganizationDetails(res.data);
            let data = {
                PhoneNumberID: state?.ID || props.PhoneNumberData.id,
                PhoneNumberToRecharge: state?.PhoneNumber || props.PhoneNumberData.PhoneNumber,
                ProductType: state?.ProductType || props.PhoneNumberData.SelectProduct,
                Organization: org,
                IsRecharge: true,
                IsAddonRecharge: state?.Status === PhoneNumberStatus.ACTIVE || props.PhoneNumberData.status === PhoneNumberStatus.ACTIVE,
                PhonePlans: state?.Plans || props.PhoneNumberData.plans,
                ...org,
                CurrentPlanID: state?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.PlanID || props.PhoneNumberData.plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.PlanID,
                SubscriptionID: state?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID || props.PhoneNumberData.plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID,
                // ManualPayment: setting.data.value.toLowerCase() === "true"
                // ManualPayment: false

            }
            navigate(AppRoutes.RECHARGE, { state: { ...data }, replace: true })
        }).catch(error => { })
        // ).catch(settingError => { })
    }

    useEffect(() => {
        setRefreshHandler()
    }, [])

    return (
        <div className={`w-fill m-auto ${props.IsMobileDevice && 'paper-background br-2 add-phone-number-paper-border p-2 '} `}>
            <Grid container alignContent='center' className="h-40 ">
                {props.Status === false ?
                    <>
                        <Grid item xs={12} className={"d-flex justify-center"}>
                            <AnimateLoader LoaderAnimation={RegistraionLoaderAminationData} className={`${props.IsMobileDevice ? 'w-9 pt-6' : 'w-7'} mb-2`} />
                        </Grid>
                        <Grid item xs={12} className={"d-flex justify-center p-0 mb-1"}>
                            <p className={`${props.IsMobileDevice ? 'h3' : 'h1-bold'}  color-registration-title m-0`}>{appNote.WAITING_FOR_REGISTERING_NUMBER}</p>
                        </Grid>
                        {
                            !props.IsMobileDevice ?
                                <Grid item xs={12} className={"d-flex justify-center p-0 mb-1"}> <p className={"h5-regular color-secondary-accent"}>{appNote.TAKE_SOME_TIME}<br /><span className={"d-flex justify-center"}>{appNote.REGISTRATION_COMPLETE}</span></p></Grid>
                                :
                                <Grid item xs={12} className={"d-flex justify-center p-0 mb-1"}> <p className={"h4 color-secondary-accent t-align-center"}>{appNote.TAKE_SOME_TIME_REGISTRATION_COMPLETE}</p></Grid>
                        }
                        <Grid item xs={12} className="d-flex justify-center">
                            <ButtonComponent ButtonLabel={UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS} OnClick={goToHome} Variant={"primary-btn-small"} ClassName={"px-2 mr-3"} Icon={GotoHomePageIcon} />
                        </Grid>
                    </>
                    :
                    <>
                        <Grid item xs={12} className={"d-flex justify-center "}>
                            <RegistrationSuccessIcon className={`${props.IsMobileDevice ? 'pt-6' : ''} w-6 mb-2`} />
                        </Grid>
                        <Grid item xs={12} className={"d-flex justify-center mb-1"}>
                            <span className="h1-semibold color-secondary-success">{appNote.REGISTRATION_SUCCESSFULL}</span>
                        </Grid>
                        <Grid item xs={12} className={"d-flex justify-center px-4  my-2 mb-5"}><span className={"h4-regular color-secondary-accent t-align-center"}>{UtilityService.maskPhoneNumber(state?.PhoneNumber || props.PhoneNumberData?.PhoneNumber || "")} {appNote.PHONE_REGISTRATION_COMPLETE}</span></Grid>
                        <Grid item xs={12} className="d-flex justify-center">
                            <ButtonComponent ButtonLabel={UserService.hasSysAdminRole() ? buttonLabels.GO_TO_PHONE_NUMBERS : buttonLabels.GO_TO_PLANS} OnClick={goToHome} Variant={"primary-btn-small"} ClassName={"px-2 mr-3"} Icon={GotoHomePageIcon} />
                            {!state?.IsReHost && !props.IsNewPhoneNumberFlow && <ButtonComponent ButtonLabel={buttonLabels.GO_TO_RECHARGE} OnClick={goToRecharge} Variant={"primary-btn-small"} ClassName={"px-2 "} Icon={RechargeIconWhite} />}
                        </Grid>
                    </>
                }
            </Grid>
        </div>
    )
}
export default RegistrationStatus